import { Item, itemTypeFormatters } from "@skinsoft/entity";
import { futureLocation } from "@skinsoft/entity/src/item/selectors";
import { LocationDataStore } from "@skinsoft/entity/src/location/location-data-store";
import { ReactiveVue } from "@skinsoft/reactive-vue";
import { toSearchFeatured$ } from "@skinsoft/search-data-store/src/featured";
import { getTranslatedString } from "@skinsoft/ui/src/localized-string";
import { SearchFeatured, SearchFeaturedCard } from "@skinsoft/ui/src/search-featured-card";
import _ from "lodash";
import Component from "vue-class-component";
import { Watch } from "vue-property-decorator";

@Component({
    props: ['item'],
    components: {
        sSearchFeaturedCard: SearchFeaturedCard,
    },
    template: require('./item-featured-card.html'),
})
export class ItemFeaturedCard extends ReactiveVue {
    private item: Item
    
    private searchFeatured: SearchFeatured | null = null
    private futureLocationPath: string = ''

    private $locationDataStore: LocationDataStore

    private mounted() {
        toSearchFeatured$(
            this.item,
            this.$i18n.locale,
        ).subscribe((searchFeatured) => {
            this.searchFeatured = searchFeatured
        })

        this.futureLocationPath = getTranslatedString(futureLocation(this.item)?.path, this.$i18n.locale)
    }

    private get readableCardType() {
        if(this.searchFeatured) {
            return this.$t(itemTypeFormatters.getReadableType(this.searchFeatured.itemType))
        }
    }

    @Watch('item')
    onFeaturedChange() {
        toSearchFeatured$(
            this.item,
            this.$i18n.locale,
        ).subscribe((searchFeatured) => {
            this.searchFeatured = searchFeatured
        })

        this.futureLocationPath = getTranslatedString(futureLocation(this.item)?.path, this.$i18n.locale)
    }
}